import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';
import httpRequest from 'src/helpers/httpRequest';

interface ICarecreditsObj {
    _id: string;
    awardedPoints: number;
    orderPrice: number;
};

const FindAwardedPoints: React.FC<{ totalPrice: number }> = ({ totalPrice = 0 }) => {
    const [awardedPoints, setAwardedPoints] = useState<number | null>(null);
    const [creditLoader, setCreditLoader] = useState<boolean>(false);
    const [allCreditsOptions, setAllCreditsOptions] = useState<ICarecreditsObj[]>([]);
    const fetchCarecredits = async () => {
        setCreditLoader(true);
        const { res, err } = await httpRequest<{ result: ICarecreditsObj[] }>({ path: "/care-credit/all-order-rewards" });
        if (res) {
            setAllCreditsOptions(res?.result || []);
        } else {
            toast(err, { type: "error" });
        }
        setCreditLoader(false);
    };

    const findAwardedPoints = (orderPrice: number) => {
        const sortedOptions = [...allCreditsOptions].sort((a, b) => a.orderPrice - b.orderPrice); // sort ascending
        let closestOption = null;
        for (let i = 0; i < sortedOptions.length; i++) {
            if (sortedOptions[i].orderPrice > orderPrice) {
                break; // if orderprice is greater then current order price then break.
            }
            closestOption = sortedOptions[i]; // update closest match
        }
        setAwardedPoints(closestOption ? closestOption?.awardedPoints : null);
    };

    useEffect(() => {
        fetchCarecredits();
    }, []);
    useEffect(() => {
        if (totalPrice && allCreditsOptions) {
            findAwardedPoints(totalPrice);
        }
    }, [totalPrice, allCreditsOptions]);
    return (
        <>
            {creditLoader ?
                <CircularProgress
                    size={14}
                    style={{ color: "#004540" }}
                />
                : `${awardedPoints || "0"} Point`
            }
        </>
    );
};

export default FindAwardedPoints;